<div class="topic-slider" *ngIf="!isLoading()">
  <h2 class="topic-slider__title" [tabIndex]="0">{{ topics.label }}</h2>

  <div class="topic-slider-wrapper">
    <div class="swiper__box" [class.full-width]="!homeBanner.show">
      <opac-swiper [configuration]="swiperConfiguration" [gradient]="false">
        <opac-swiper-item *ngFor="let group of facetGroups()">
          <div class="topic-item" [opac-menu-trigger]="facetsMenu">
            <span (keydown.enter)="setFacet(group.parentFacet.id)" (keydown.space)="setFacet(group.parentFacet.id)"
              (click)="setFacet(group.parentFacet.id)" [tabIndex]="0">
              {{ group.parentFacet.label }}
            </span>

            <opac-icon *ngIf="group.subFacets?.length > 0" icon="navigate_downward"
              (keydown.enter)="showSubtopics(group.parentFacet)" (keydown.space)="showSubtopics(group.parentFacet)"
              (click)="showSubtopics(group.parentFacet)" [tabIndex]="0"
              [attr.aria-label]="('general.subtopicOf' | translate) + ' ' + group.parentFacet.label"></opac-icon>
          </div>

          <opac-menu #facetsMenu>
            <opac-menu-item *ngFor="let subFacet of group.subFacets" (selected)="setFacet(subFacet.id)">
              <span>{{ subFacet.label }}</span>
            </opac-menu-item>
          </opac-menu>
        </opac-swiper-item>
      </opac-swiper>
    </div>

    <div class="topic-slider__banner" *ngIf="homeBanner.show">
      <img [src]="bannerImageUrl" [class.clickable]="homeBanner.targetUrl" (keydown.enter)="openBannerUrl()"
        [attr.aria-label]="
          !this.homeBanner.targetUrl
            ? ('general.banner' | translate)
            : ('common.goto' | translate) + ' ' + this.homeBanner.targetUrl
        " (keydown.space)="openBannerUrl()" (click)="openBannerUrl()" tabindex="0" alt="Banner image" />
    </div>
  </div>

  <div class="topic-slider__action">
    <button mat-flat-button (click)="searchFacets()" tabindex="0">{{ 'common.viewAll' | translate }}</button>
  </div>
</div>

<mat-menu #topicMenu="matMenu" class="topic-slider__menu">
  <button mat-menu-item *ngFor="let subtopic of subtopics" (keydown.enter)="open(subtopic)"
    (keydown.space)="open(subtopic)" (click)="open(subtopic)">
    {{ subtopic.label }}
  </button>
</mat-menu>